import React, { useEffect, Fragment } from "react";
import useGetCast from "../custom-hooks/useGetCast";

import Text from "./Text";
import { castGet, castGetSeries } from "../constants";
import "../assets/styles/components/Casting.scss";

import Error from "./Error";
import Loader from "./Loader";
import Cast from "./Cast";

const Casting = (props) => {
  const movieId = props.data;
  const { casting, loading, error, getCast } = useGetCast(
    props.uri === "series" ? `${castGetSeries(movieId)}` : `${castGet(movieId)}`
  );

  useEffect(() => {
    getCast();
  });

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Error />
      ) : (
        <>
          <Text text="Casting" />
          <div className="castList">
            {casting.map((cast) => (
              <Cast key={cast.id} data={cast} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Casting;

